export default "__VITE_ASSET__CKHl8B1k__"